import { createContext, useContext } from "react";
import { useStore } from "zustand";
import { useShallow } from "zustand/react/shallow";

import { MatchesState, MatchesStoreContextType, MatchesStoreType } from "./matches_store.types";

export const MatchesStoreContext = createContext<MatchesStoreContextType>({} as MatchesStoreContextType);

export const useMatchesStore = <U>(selector: (state: MatchesStoreType) => U) => {
  const store = useContext(MatchesStoreContext);

  return useStore(store, useShallow(selector));
};

export const useMatchesActions = () => {
  const store = useContext(MatchesStoreContext);

  return useStore(store, (state) => state.actions);
};

export const getInitialMatchesState = (): MatchesState => ({
  matchesParams: {
    page: 1,
    perPage: 10,
    highlights: true
  }
});
